const solutions = [
  {
    title: '에너지 수요 예측',
    desc: 'AI 기반 실시간 수요 예측으로 최적 운영',
    metric: '30%',
    metricLabel: '효율 향상',
    image:
      'https://readdy.ai/api/search-image?query=AI%20energy%20demand%20forecasting%20dashboard%20with%20neon%20cyan%20and%20green%20charts%20and%20graphs%20on%20dark%20slate%20background%20futuristic%20data%20visualization%20abstract%20technology%20interface%20high%20quality%203D%20render&width=500&height=600&seq=sol1&orientation=portrait',
  },
  {
    title: '탄소중립 관리',
    desc: '실시간 탄소 배출량 모니터링 및 감축',
    metric: '50%',
    metricLabel: '감축률',
    image:
      'https://readdy.ai/api/search-image?query=Carbon%20neutral%20management%20platform%20visualization%20with%20green%20leaf%20and%20energy%20metrics%20on%20dark%20slate%20background%20neon%20cyan%20and%20green%20data%20displays%20futuristic%20eco%20technology%20high%20quality%203D%20render&width=500&height=600&seq=sol2&orientation=portrait',
  },
  {
    title: '재생에너지 통합',
    desc: '태양광·풍력 등 분산 전원 통합 운영',
    metric: '99.9%',
    metricLabel: '가동률',
    image:
      'https://readdy.ai/api/search-image?query=Renewable%20energy%20integration%20system%20with%20solar%20panels%20wind%20turbines%20and%20smart%20grid%20connections%20dark%20slate%20background%20neon%20cyan%20and%20green%20energy%20flows%20futuristic%20power%20infrastructure%20high%20quality%203D%20render&width=500&height=600&seq=sol3&orientation=portrait',
  },
  {
    title: '에너지 효율화 AI',
    desc: '건물 및 공장 에너지 사용 최적화',
    metric: '25%',
    metricLabel: '절감률',
    image:
      'https://readdy.ai/api/search-image?query=AI%20energy%20efficiency%20optimization%20for%20smart%20building%20and%20factory%20with%20neon%20cyan%20and%20green%20sensor%20networks%20dark%20slate%20background%20futuristic%20industrial%20automation%20high%20quality%203D%20render&width=500&height=600&seq=sol4&orientation=portrait',
  },
];

export default function SolutionsSection() {
  return (
    <section id="solutions" className="relative py-24 md:py-32 bg-enerverze-bg">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-start justify-between mb-12">
          <div>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-enerverze-text leading-tight mb-3">
              <span className="text-neon-cyan">AI</span> 솔루션
            </h2>
            <p className="text-sm text-enerverze-subtle">
              에너버즈의 AI 기반 에너지 솔루션 포트폴리오
            </p>
          </div>
          <div className="hidden md:flex items-center px-4 py-2 rounded-full border border-neon-cyan text-neon-cyan text-sm">
            AI Solution
          </div>
        </div>

        <div className="flex gap-5 overflow-x-auto pb-4 scrollbar-hide">
          {solutions.map((sol) => (
            <div
              key={sol.title}
              className="flex-shrink-0 w-72 md:w-80 rounded-3xl overflow-hidden bg-enerverze-card border border-enerverze-border hover:border-neon-cyan transition-all duration-300"
            >
              <div className="h-72 md:h-80 overflow-hidden">
                <img
                  src={sol.image}
                  alt={sol.title}
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <div className="p-5">
                <div className="flex items-start justify-between mb-3">
                  <div>
                    <h3 className="text-base font-semibold text-enerverze-text mb-1">
                      {sol.title}
                    </h3>
                    <p className="text-xs text-enerverze-muted leading-relaxed">
                      {sol.desc}
                    </p>
                  </div>
                  <div className="text-right flex-shrink-0 ml-3">
                    <p className="text-2xl font-bold text-neon-cyan">{sol.metric}</p>
                    <p className="text-xs text-enerverze-subtle">{sol.metricLabel}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}